import React, { Component, PropTypes } from 'react';
import TableRows from './TableRows';
import { SparkTable } from '../../../ui/spark';

class TablePanel extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.themeTable = new SparkTable(this.themeTableMount);
    }

    tableHeaders() {
        const { columns = {}, firstColumn, secondColumn } = this.props;
        const columnHeaders = _.values(columns);
        const useColumnHeaders = !_.isEmpty(columnHeaders);
        const firstColumnHeader = useColumnHeaders ? _.get(columnHeaders, 0) : firstColumn;
        const secondColumnHeader = useColumnHeaders ? _.get(columnHeaders, 1) : secondColumn;

        if (this.props.single) {
            return (
                <tr>
                    <th data-sort="asc">{firstColumnHeader}</th>
                    <th>Action</th>
                </tr>
            );
        } else {
            return (
                <tr>
                    <th data-sort="asc">{firstColumnHeader}</th>
                    <th>{secondColumnHeader}</th>
                    <th>Action</th>
                </tr>
            );
        }
    }

    render() {
        return (
            <div
                ref={node => {
                    this.themeTableMount = node;
                }}
            >
                <table
                    id={this.props.id + '-theme-panel-table'}
                    className="col-lg-12 spark-table col-xs-12"
                    role="grid"
                >
                    <thead>{this.tableHeaders()}</thead>
                    <TableRows
                        list={this.props.list}
                        isDisabled={this.props.isDisabled}
                        editConfigRow={this.props.editConfigRow}
                        deleteConfigRow={this.props.deleteConfigRow}
                        single={this.props.single}
                        columns={this.props.columns}
                    />
                </table>
            </div>
        );
    }
}

TablePanel.propTypes = {
    themes: PropTypes.array,
    onShowInfo: PropTypes.func
};

export default TablePanel;



// WEBPACK FOOTER //
// ./src/components/pages/pages/configurationListSettings/TablePanel.js